/**
 * BabylonJS Global Shim
 * This file exports the global BABYLON object loaded from CDN
 * as ES modules for import compatibility
 */

// Get reference to the global BABYLON object
const BABYLON = window.BABYLON || {};

// Export default
export default BABYLON;

// Re-export commonly used classes and functions for named imports
export const Engine = BABYLON.Engine;
export const Scene = BABYLON.Scene;
export const ArcRotateCamera = BABYLON.ArcRotateCamera;
export const FreeCamera = BABYLON.FreeCamera;
export const UniversalCamera = BABYLON.UniversalCamera;
export const HemisphericLight = BABYLON.HemisphericLight;
export const DirectionalLight = BABYLON.DirectionalLight;
export const PointLight = BABYLON.PointLight;
export const SpotLight = BABYLON.SpotLight;
export const Vector3 = BABYLON.Vector3;
export const Vector2 = BABYLON.Vector2;
export const Color3 = BABYLON.Color3;
export const Color4 = BABYLON.Color4;
export const Space = BABYLON.Space;
export const Axis = BABYLON.Axis;
export const Mesh = BABYLON.Mesh;
export const MeshBuilder = BABYLON.MeshBuilder;
export const TransformNode = BABYLON.TransformNode;
export const AbstractMesh = BABYLON.AbstractMesh;
export const SceneLoader = BABYLON.SceneLoader;
export const Animation = BABYLON.Animation;
export const AnimationGroup = BABYLON.AnimationGroup;
export const AnimationPropertiesOverride = BABYLON.AnimationPropertiesOverride;
export const Bone = BABYLON.Bone;
export const Skeleton = BABYLON.Skeleton;
export const PBRMaterial = BABYLON.PBRMaterial;
export const StandardMaterial = BABYLON.StandardMaterial;
export const Texture = BABYLON.Texture;
export const CubeTexture = BABYLON.CubeTexture;
export const MorphTarget = BABYLON.MorphTarget;
export const Debug = BABYLON.Debug;
export const EnvironmentHelper = BABYLON.EnvironmentHelper;
export const Layer = BABYLON.Layer;
export const ActionManager = BABYLON.ActionManager;
export const ExecuteCodeAction = BABYLON.ExecuteCodeAction;
export const Observable = BABYLON.Observable;
export const Observer = BABYLON.Observer;
export const PointerEventTypes = BABYLON.PointerEventTypes;
export const PointerInfo = BABYLON.PointerInfo;
export const KeyboardEventTypes = BABYLON.KeyboardEventTypes;
export const KeyboardInfo = BABYLON.KeyboardInfo;
export const Nullable = BABYLON.Nullable;
export const AxesViewer = BABYLON.AxesViewer;
export const IAnimationKey = BABYLON.IAnimationKey;
export const MorphTargetManager = BABYLON.MorphTargetManager;

// For loaders
export const GLTF2 = BABYLON.GLTF2;
export const GLTFFileLoader = BABYLON.GLTFFileLoader;

